import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { OtherSpiritType } from 'src/app/products/interfaces/models';

import { OtherSpiritProperties } from '@app/api/marketplace/models';
import {
  RequiredExceptions,
  SubformBaseWithSugarContentPropertiesComponent,
} from '@products/components/forms/subform-base-with-sugar-content-properties/subform-base-with-sugar-content-properties.component';

@Component({
  selector: 'app-other-spirit-properties-subform',
  templateUrl: './other-spirit-properties-subform.component.html',
  styleUrls: ['./other-spirit-properties-subform.component.scss'],
})
export class OtherSpiritPropertiesSubformComponent extends SubformBaseWithSugarContentPropertiesComponent {
  override alcoholic = true;
  DICT_PATH = 'PRODUCTS.OTHER_SPIRIT_PROPERTIES';

  types = OtherSpiritType;

  static requiredExceptions: RequiredExceptions = {
    sugarContentType: false,
  };

  static buildForm(fb: FormBuilder, data?: OtherSpiritProperties) {
    return fb.group({
      type: [data?.type, Validators.required],
      distilled: data?.distilled ?? false,

      // build sugar content properties
      ...{
        sugarContentProperties:
          SubformBaseWithSugarContentPropertiesComponent.buildFields(
            data?.sugarContentProperties,
            this.requiredExceptions,
            true,
            fb
          ),
      },
    });
  }
}
